// extracted by mini-css-extract-plugin
export var haloGlow = "XboxSpinner-module__haloGlow___ALrxU";
export var logo = "XboxSpinner-module__logo___1AyRo";
export var logoEclipse = "XboxSpinner-module__logoEclipse___ch2fS";
export var orbitEclipse = "XboxSpinner-module__orbitEclipse___76Tt6";
export var rotate = "XboxSpinner-module__rotate___wEueF";
export var spinner = "XboxSpinner-module__spinner___617+m";